enum Specialization {
    PRODOTTI_LIFE = 'prodotti life',
    PRODOTTI_CAMPER = 'prodotti camper',
    PRODOTTI_COMMERCE = 'prodotti commerce',
}

export default Specialization
